module.exports = __webpack_public_path__ + "static/media/menu-overlay-contact.30394859.jpg";